import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppPwa } from './AppPwa';
import { GamePrefsProvider } from './state/GamePrefsProvider';
import './styles.css';

const root = document.getElementById('root');
if (!root) {
  throw new Error('Missing #root');
}

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <GamePrefsProvider>
        <AppPwa />
      </GamePrefsProvider>
    </BrowserRouter>
  </StrictMode>
);
